













import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {
    @Prop({ required: true }) current!: number;
    @Prop({ required: true }) max!: number;
    @Prop({ default: 0 }) min!: number;

    get progressPercentage(): number {
        return Math.min(Math.max((this.current / this.max) * 100, 0), 100);
    }
}
